import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import { APP_TYPES } from '@/utils/constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () =>
        import(/* webpackChunkName: "Layout" */ '@/views/Layout'),
      meta: {
        auth: true
      },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () =>
            import(/* webpackChunkName: "Dashboard" */ '@/views/Dashboard'),
          meta: {
            auth: true
          }
        },
        {
          path: '/invoices',
          name: 'invoices',
          component: () =>
            import(/* webpackChunkName: 'Invoices' */ '@/views/Invoices/index'),
          props: true,
          meta: {
            auth: true
          }
        },
        {
          path: '/invoices/add/:id?/:value?',
          name: 'invoicesAdd',
          component: () =>
            import(/* webpackChunkName: "dashboard" */ '@/views/Invoices/Add'),
          meta: {
            auth: true
          }
        },
        {
          path: '/invoices/esign',
          name: 'invoicesEsign',
          component: () =>
            import(
              /* webpackChunkName: "InvoicesEsign" */ '@/views/Invoices/Esign'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/invoices/:id/upload',
          name: 'invoicesUpload',
          component: () =>
            import(
              /* webpackChunkName: "InvoicesUpload" */ '@/views/Invoices/Upload'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/invoices/:id',
          name: 'invoicesSingle',
          component: () =>
            import(
              /* webpackChunkName: "InvoiceSingle" */ '@/views/Invoices/Single'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/account',
          name: 'account',
          component: () =>
            import(/* webpackChunkName: "Account" */ '@/views/Account'),
          meta: {
            auth: true
          }
        },
        {
          path: '/currencySettings',
          name: 'currencySettings',
          component: () =>
            import(
              /* webpackChunkName: "CurrencySettings" */ '@/views/CurrencySettings'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/transactions',
          name: 'transactions',
          component: () =>
            import(
              /* webpackChunkName: "Transactions" */ '@/views/Transactions'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/buyers',
          name: 'buyers',
          component: () =>
            import(/* webpackChunkName: "Buyers" */ '@/views/Buyers'),
          meta: {
            auth: true
          }
        },
        {
          path: '/buyers/add/:buyerId',
          name: 'buyersAdd',
          component: () =>
            import(/* webpackChunkName: "BuyersAdd" */ '@/views/Buyers/Add'),
          meta: {
            auth: true
          }
        },
        {
          path: '/buyers/:id',
          name: 'buyersSingle',
          component: () =>
            import(
              /* webpackChunkName: "BuyerSingle" */ '@/views/Buyers/Single'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/accountSummary',
          name: 'accountSummary',
          component: () =>
            import(
              /* webpackChunkName: "AccountSummary" */ '@/views/AccountSummary/'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/remittances',
          name: 'remittances',
          component: () =>
            import(
              /* webpackChunkName: "BankAccounts" */ '@/views/Remittances'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/view-remittance/:rid',
          name: 'viewRemittance',
          component: () =>
            import(
              /* webpackChunkName: "ViewRemittance" */ '@/views/Remittances/ViewRemittance'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/add-remittance',
          name: 'addRemittance',
          component: () =>
            import(
              /* webpackChunkName: "AddRemittance" */ '@/views/Remittances/AddRemittance'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/insights',
          name: 'insights',
          component: () =>
            import(/* webpackChunkName: "DripOne" */ '@/views/DripOne/'),
          meta: {
            auth: true
          }
        },
        {
          path: '/resources/bank-holidays',
          name: 'bankHolidays',
          component: () =>
            import(
              /* webpackChunkName: "BankHolidays" */ '@/views/BankHolidays/'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/resources/charges-calculator',
          name: 'chargesCalculator',
          component: () =>
            import(
              /* webpackChunkName: "ChargesCalculator" */ '@/views/ChargesCalculator/'
            )
        },
        {
          path: '/resources/cma-list',
          name: 'cmaList',
          component: () =>
            import(/* webpackChunkName: "CmaList" */ '@/views/CmaList/'),
          meta: {
            auth: true
          }
        },
        {
          path: '/resources/master-bl-list',
          name: 'masterBlList',
          component: () =>
            import(
              /* webpackChunkName: "MasterBlList" */ '@/views/MasterBlList/'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/bank-accounts',
          name: 'bankAccounts',
          component: () =>
            import(
              /* webpackChunkName: "BankAccountsList" */ '@/views/AddBank/BankList'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/view-bank/:bid',
          name: 'viewBank',
          component: () =>
            import(
              /* webpackChunkName: "ViewBank" */ '@/views/AddBank/ViewBank'
            ),
          meta: {
            auth: true
          }
        },
        {
          path: '/add-bank-account/:bid?',
          name: 'addBankAccount',
          component: () =>
            import(/* webpackChunkName: "AddBankAccounts" */ '@/views/AddBank'),
          meta: {
            auth: true
          }
        }
      ]
    },
    {
      path: '/login/:form?',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "Login" */ '@/views/Login/NewLogin'),
      meta: {
        auth: false
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: () =>
        import(/* webpackChunkName: "Login" */ '@/views/Login/Logout')
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: () =>
        import(
          /* webpackChunkName: "ForgotPassword" */ '@/views/Login/NewForgotPassword'
        ),
      meta: {
        auth: false
      }
    },
    {
      path: '/reset-password/:code',
      name: 'resetPassword',
      component: () =>
        import(
          /* webpackChunkName: "NewResetPassword" */ '@/views/Login/NewResetPassword'
        ),
      meta: {
        auth: false
      }
    },
    {
      // Handling drip assist case, where we need to authenticate the user out of the mobile application.
      // IOS browser not storing the token for some reason, when a user closes and reopens browser.
      path: '/drip-assist',
      beforeEnter: (to) => {
        const { token } = to.query
        const defaultToken = localStorage.getItem('default_auth_token')
        const isRemember = Cookies.get('rememberMe')
        if (!defaultToken) {
          localStorage.setItem('default_auth_token', token)
        }
        if (!isRemember) {
          Cookies.set('rememberMe', true)
        }
        // store it in a env variable
        window.location.href = 'https://dripassist.freshdesk.com/customer/login'
      }
    },
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/importers',
      component: () =>
        import(
          /* webpackChunkName: "ImportersLayout" */ '@/views/Importers/Layout'
        ),
      meta: {
        auth: true
      },
      children: [
        {
          path: '',
          name: 'importerDashboard',
          component: () =>
            import(
              /* webpackChunkName: "ImportersInvoices" */ '@/views/Importers/Invoices'
            )
        },
        {
          path: 'esign',
          name: 'importerEsign',
          component: () =>
            import(
              /* webpackChunkName: "ImportersEsign" */ '@/views/Importers/Esign'
            ),
          props: true
        },
        {
          path: 'list-esign',
          name: 'listEsign',
          component: () =>
            import(
              /* webpackChunkName: "ImportersListEsign" */ '@/views/Importers'
            ),
          props: true
        }
      ]
    },
    {
      path: '/legal-sign',
      component: () =>
        import(/* webpackChunkName: "LegalLayout" */ '@/views/Legal/Layout'),
      meta: {
        auth: true
      },
      children: [
        {
          path: '',
          name: 'generateLegal',
          component: () =>
            import(/* webpackChunkName: "LegalInvoices" */ '@/views/Legal')
        },
        {
          path: 'legalEsign',
          name: 'legalEsign',
          component: () =>
            import(/* webpackChunkName: "LegalEsign" */ '@/views/Legal/Esign'),
          props: true
        }
      ]
    },
    {
      path: '/digilocker',
      component: () =>
        import(
          /* webpackChunkName: "DigilockerLayout" */ '@/views/Digilocker/Layout'
        ),
      children: [
        {
          path: 'verify',
          name: 'digiLockerVerify',
          component: () =>
            import(
              /* webpackChunkName: "digiLockerVerify" */ '@/views/Digilocker/Verify'
            ),
          props: true
        },
        {
          path: 'status',
          name: 'digiLockerStatus',
          component: () =>
            import(
              /* webpackChunkName: "digiLockerStatus" */ '@/views/Digilocker/Status'
            ),
          props: true
        }
      ]
    },
    {
      path: '/public',
      component: () =>
        import(/* webpackChunkName: "LayoutPublic" */ '@/views/Public/Layout'),
      children: [
        {
          path: 'invoices/:id?/token/:auth_token?',
          name: 'singleInvoicePublic',
          component: () =>
            import(
              /* webpackChunkName: "InvoicesPublic" */ '@/views/Public/Invoice'
            )
        }
      ]
    },
    {
      path: '/secure',
      component: () =>
        import(
          /* webpackChunkName: "LayoutPublicSecure" */ '@/views/Public/Layout'
        ),
      children: [
        {
          path: 'quick-esign/:url?',
          name: 'quickEsign',
          component: () =>
            import(
              /* webpackChunkName: "QuickEsignPublic" */ '@/views/Public/QuickEsign'
            )
        },
        {
          path: 'invoices/:id?/token/:auth_token?',
          name: 'singleInvoiceSecure',
          component: () =>
            import(
              /* webpackChunkName: "InvoicesPublicSecure" */ '@/views/Public/Invoice'
            )
        }
      ]
    },
    {
      path: '/freshdesk/sso/customer/jwt/login',
      component: () =>
        import(/* webpackChunkName: "Freshdesk" */ '@/views/Freshdesk'),
      meta: {
        auth: true
      }
    },
    {
      path: '/testSentry',
      component: () => import(/* webpackChunkName: "Error" */ '@/views/Error'),
      meta: {
        auth: false
      }
    },
    {
      path: '/dripSign',
      name: 'dripSign',
      component: () =>
        import(/* webpackChunkName: "ClickWrap" */ '@/views/ClickWrap'),
      meta: {
        auth: true
      }
    },
    {
      path: '/vue-library',
      component: () =>
        import(/* webpackChunkName: "Library" */ '@/views/Library'),
      meta: {
        auth: false
      }
    }
  ]
})

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
  if (['addRemittance'].includes(from.name) && !to.params.ignoreDialog) {
    const flag = confirm('Changes you made may not be saved')
    if (!flag) {
      return false
    }
  }

  const token = Cookies.get('token', { domain: '.dripcapital.com' })
  const userId = Cookies.get('user_id', { domain: '.dripcapital.com' })
  const userTarget = Cookies.get('user_target', { domain: '.dripcapital.com' })

  const isTokenInvalid = !Cookies.get('default_auth_token', {
    domain: '.dripcapital.com'
  })

  if (to.meta.auth && isTokenInvalid) {
    let urlPath =
      process.env.VUE_APP_DRIP_PORTAL_HOST +
      `/login?app=${APP_TYPES.RFP}&callback=${location.href.replace(
        location.origin,
        ''
      )}`
    window.location.href = urlPath
  }

  if (token && userId && userTarget === 'onboarding') {
    window.location.href = process.env.VUE_APP_NDAJ_HOST
  } else next()
})

export default router
